import React from "react";
// import { Link } from "react-router-dom";
import 'owl.carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';



export default class Home extends React.Component {

    plans = [
        {
            name: 'Basic',
            price: '$9/mo',
            features: ['1 User', '5GB Storage', 'Email Support'],
            buttonText: 'Get Started',
        },
        {
            name: 'Pro',
            price: '$29/mo',
            features: ['5 Users', '50GB Storage', 'Priority Email Support'],
            buttonText: 'Upgrade Now',
            highlighted: true,
        },
        {
            name: 'Enterprise',
            price: '$99/mo',
            features: ['Unlimited Users', '1TB Storage', 'Phone & Email Support'],
            buttonText: 'Contact Sales',
        },
    ];

    render(){
        return(
            <div>
                <div class="wrapper">
                    <section class="slider-container">
                        <div class="slider-outer">
                            <div class="tp-banner-container">
                                <div class="tp-banner">
                                <ul>
                                    <div class="owl-carousel owl-theme">
                                        <div>
                                            <li data-transition="fade" data-slotamount="7" data-masterspeed="1000" data-thumb="/assets/images/thumb1.jpg" data-delay="5000"  data-saveperformance="on"  data-title="Slide">
                                                {/* <!-- MAIN IMAGE --> */}
                                                {/* <img src="/assets/images/dummy.png"  alt="slider" data-lazyload="/assets/images/slider1.jpg" data-bgposition="center center" data-bgfit="cover" data-bgrepeat="no-repeat"/> */}                                                                                        <img src="/assets/images/dummy.png"  alt="slider" data-lazyload="/asssts/images/slider1.jpg" data-bgposition="center center" data-bgfit="cover" data-bgrepeat="no-repeat"/>
                                                <img src="assets/images/tslider1.png"  alt="slider" data-lazyload="assets/images/tslider1.png" data-bgposition="center center" data-bgfit="cover" data-bgrepeat="no-repeat"/>
                                                <div class="tp-caption very_large_text"
                                                    data-x="center"
                                                    data-y="center"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}>WELCOME to FOOD TRUCK
                                                </div>
                                                <div class="tp-caption large_text"
                                                    data-x="center"
                                                    data-y="405"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}>Check now our menu and see the Schedule
                                                </div>
                                                <div class="tp-caption btn-menu-top"
                                                    data-x="400"
                                                    data-y="465"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}><a href="#/" class="btn-black">Check menu</a>
                                                </div>
                                                <div class="tp-caption btn-menu-bottom"
                                                    data-x="570"
                                                    data-y="465"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}><a href="#/" class="btn-black">See schedule</a>
                                                </div> 
                                            </li>
                                        </div>
                                        <div>
                                            <li data-transition="zoomin" data-slotamount="7" data-masterspeed="1500" data-thumb="images/thumb1.jpg" data-delay="5000"  data-saveperformance="on"  data-title="Slide">
                                                {/* <!-- MAIN IMAGE --> */}
                                                {/* <img src="assets/images/dummy.png"  alt="slider" data-lazyload="images/slider2.jpg" data-bgposition="center center" data-bgfit="cover" data-bgrepeat="no-repeat"/> */}
                                                <img src="assets/images/tslider2.png"  alt="slider" data-lazyload="assets/images/tslider2.png" data-bgposition="center center" data-bgfit="cover" data-bgrepeat="no-repeat"/>
                                                <div class="tp-caption very_large_text"
                                                    data-x="center"
                                                    data-y="center"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}>WELCOME to FOOD TRUCK
                                                </div>
                                                <div class="tp-caption large_text"
                                                    data-x="center"
                                                    data-y="405"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}>Check now our menu and see the chedule
                                                </div>
                                                <div class="tp-caption btn-menu-top"
                                                    data-x="400"
                                                    data-y="465"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}><a href="#/" class="btn-black">Check menu</a>
                                                </div>
                                                <div class="tp-caption btn-menu-bottom"
                                                    data-x="570"
                                                    data-y="465"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}><a href="#/" class="btn-black">See schedule</a>
                                                </div> 
                                            </li>
                                        </div>
                                        <div>
                                            <li data-transition="fade" data-slotamount="7" data-masterspeed="2000" data-thumb="images/thumb1.jpg" data-delay="5000"  data-saveperformance="on"  data-title="Slide">
                                                {/* <!-- MAIN IMAGE --> */}
                                                <img src="assets/images/dummy.png"  alt="slider" data-lazyload="images/slider3.jpg" data-bgposition="center center" data-bgfit="cover" data-bgrepeat="no-repeat"/>
                                                <div class="tp-caption very_large_text"
                                                    data-x="center"
                                                    data-y="center"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}>WELCOME to FOOD TRUCK
                                                </div>
                                                <div class="tp-caption large_text"
                                                    data-x="center"
                                                    data-y="405"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}>Check now our menu and see the chedule
                                                </div>
                                                <div class="tp-caption btn-menu-top"
                                                    data-x="400"
                                                    data-y="465"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}><a href="#/" class="btn-black">Check menu</a>
                                                </div>
                                                <div class="tp-caption btn-menu-bottom"
                                                    data-x="570"
                                                    data-y="465"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}><a href="#/" class="btn-black">See schedule</a>
                                                </div> 
                                            </li>
                                        </div>
                                        <div>
                                            <li data-transition="zoomin" data-slotamount="7" data-masterspeed="2500" data-thumb="images/thumb1.jpg" data-delay="5000"  data-saveperformance="on"  data-title="Slide">
                                                {/* <!-- MAIN IMAGE --> */}
                                                <img src="images/dummy.png"  alt="slider" data-lazyload="images/slider4.jpg" data-bgposition="center center" data-bgfit="cover" data-bgrepeat="no-repeat"/>
                                                <div class="tp-caption very_large_text"
                                                    data-x="center"
                                                    data-y="center"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}>WELCOME to FOOD TRUCK
                                                </div>
                                                <div class="tp-caption large_text"
                                                    data-x="center"
                                                    data-y="405"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}>Check now our menu and see the chedule
                                                </div>
                                                <div class="tp-caption btn-menu-top"
                                                    data-x="400"
                                                    data-y="465"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}><a href="#/" class="btn-black">Check menu</a>
                                                </div>
                                                <div class="tp-caption btn-menu-bottom"
                                                    data-x="570"
                                                    data-y="465"
                                                    data-speed="800"
                                                    data-start="3300"
                                                    data-easing="Power4.easeOut"
                                                    data-endspeed="300"
                                                    data-endeasing="Power1.easeIn"
                                                    data-captionhidden="off"
                                                    style={{"z-index": "6"}}><a href="#/" class="btn-black">See schedule</a>
                                                </div> 
                                            </li>
                                        </div>
                                    </div>
                                </ul>
                                <div class="tp-bannertimer"></div>
                                </div>
                            </div>
                        </div> {/* <!-- slider-outer --> */}
                    </section> {/* <!-- slider-container --> */}
                    <img src="assets/images/sliderbanner.jpg" alt="" style={{width:'100%',height:'90vh'}}/>




                    <div class="main-part">
                        <section class="our-client-container">
                            <div class="container"> 
                                <div class="heading wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div class="row">
                                        <div class="text-center col-sm-12">
                                            <h2>Healthy South Indian Food in Hyderabad with Grandma's Touch - Welcome to Village Cafe</h2>
                                        </div>
                                    </div> 
                                </div> {/* <!-- heading --> */}
                                <div class="our-client text-left">
                                    <div class="col-md-12 col-sm-12 col-xs-12">
                                        <div class="client-content wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                            <p style={{fontSize:18}}><span class="quort">“</span>At <span style={{fontWeight:'700'}}>Village Cafe</span>, we bring back the joy of <span style={{fontWeight:'700'}}>traditional village-style food in hyderabad</span> while keeping it <span style={{fontWeight:'700'}}>light, nutritious, and calorie-conscious</span>. From <span style={{fontWeight:'700'}}>millet breakfasts</span> and <span style={{fontWeight:'700'}}>jowar rotis</span> to wholesome <span style={{fontWeight:'700'}}>village thalis</span>, our recipes carry the <span style={{fontWeight:'700'}}>grandma's touch</span> - nostalgic flavours with modern wellness.</p>
                                        </div> {/* <!-- client-content --> */} 
                                    </div>
                                </div>
                                <div class="our-client text-left">
                                    <div class="col-md-12 col-sm-12 col-xs-12">
                                        <div class="client-content wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                            <p style={{fontSize:18}}><span class="quort">“</span>Choose from<span style={{fontWeight:'700'}}> dine-in at our cafe, food trucks at multiple Hyderabad locations</span>, or our<span style={{fontWeight:'700'}}> food suscription plans </span>for fresh, homely meals every day.</p>
                                        </div> {/* <!-- client-content --> */} 
                                    </div>
                                </div>
                            </div>
                        </section>

                        <section class="shedule-container">
                            <div class="shedule-part">
                            <div class="container" style={{display: 'flex', alignItems: 'center'}}>
                                <div class="shedule-left">
                                    <img src="assets/images/shedule-left.jpg" alt=""/>
                                </div>
                                <div class="shedule-right">
                                    <img src="assets/images/shedule-bg.jpg" alt=""/>
                                    <div class="shedule-content">
                                        <h2>Our Shedule</h2>
                                        <h3>Food truck</h3>
                                        <div class="shedule-inside">
                                        <h6>Monday-Friday: 800<sup>00</sup> - 2000<sup>00</sup></h6>
                                        <h6>Saturday: 900<sup>00</sup> - 1700<sup>00</sup></h6>
                                        <h6>Sunday: closed</h6>
                                        </div>
                                        <h3>Catering</h3>
                                        <div class="shedule-inside">
                                        <h6>Monday-Friday: 800<sup>00</sup> - 2400<sup>00</sup></h6>
                                        <h6>Saturday: 900<sup>00</sup> - 2200<sup>00</sup></h6>
                                        <h6>Sunday: closed</h6>
                                        </div>
                                        <div class="free-juice">
                                        <p>*Daily first 5 clients receive a free juice</p>
                                        </div>
                                        <div class="glass">
                                        <img src="assets/images/glass.png" alt=""/>
                                        </div>
                                    </div> {/* <!-- shedule-content --> */}
                                </div>
                            </div> {/* <!-- container --> */}
                            </div> {/* <!-- shedule-part --> */}
                        </section> {/* <!-- shedule-container --> */}
                        <section class="gallery-container">
                            <div class="container">
                            <div class="heading wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
                                <div class="row">
                                    <div class="text-center col-sm-12">
                                        <h2>Our gallery</h2>
                                    </div>
                                </div> 
                            </div> {/* <!-- heading --> */}
                            </div>
                            <div class="gallery-outer"> 
                            <div class="col-md-6 col-sm-6 col-xs-12 left-gallery" data-wow-duration="1000ms" data-wow-delay="400ms">
                                <div class="col-md-4 col-sm-4 col-xs-4 gallery-item">
                                <a href="#/"><img src="assets/images/gallery-big-right1.jpg" alt=""/><i class="fa fa-plus" aria-hidden="true"></i></a>
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-4 gallery-item">
                                <a href="#/"><img src="assets/images/gallery-big-right2.jpg" alt=""/><i class="fa fa-plus" aria-hidden="true"></i></a>
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-4 gallery-item">
                                <a href="#/"><img src="assets/images/gallery-big-right3.jpg" alt=""/><i class="fa fa-plus" aria-hidden="true"></i></a>
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-4 gallery-item">
                                <a href="#/"><img src="assets/images/gallery-big-right4.jpg" alt=""/><i class="fa fa-plus" aria-hidden="true"></i></a>
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-4 gallery-item">
                                <a href="#/"><img src="assets/images/gallery-big-right5.jpg" alt=""/><i class="fa fa-plus" aria-hidden="true"></i></a>
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-4 gallery-item">
                                <a href="#/"><img src="assets/images/gallery-big-right6.jpg" alt=""/><i class="fa fa-plus" aria-hidden="true"></i></a>
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-4 gallery-item">
                                <a href="#/"><img src="assets/images/gallery-big-right7.jpg" alt=""/><i class="fa fa-plus" aria-hidden="true"></i></a>
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-4 gallery-item">
                                <a href="#/"><img src="assets/images/gallery-big-right8.jpg" alt=""/><i class="fa fa-plus" aria-hidden="true"></i></a>
                                </div>
                                <div class="col-md-4 col-sm-4 col-xs-4 gallery-item">
                                <a href="#/"><img src="assets/images/gallery-big-right9.jpg" alt=""/><i class="fa fa-plus" aria-hidden="true"></i></a>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-xs-12 right-gallery wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="500ms">
                                <div class="gallery-block-right gallery clearfix">
                                <a href="assets/images/gallery-big-right1.jpg" rel="prettyPhoto[gallery1]"><img src="/assets/images/gallery-big-right1.jpg" alt=""/><i class="fa fa-plus" aria-hidden="true"></i></a>
                                </div>
                            </div>
                            </div> {/* <!-- gallery-outer --> */}
                        </section> {/* <!-- gallery-container --> */}
                        <section class="product-container">
                            <div class="container">
                                <div class="heading wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <div class="row">
                                    <div class="text-center col-sm-12">
                                        <h2>Check our dishes</h2>
                                    </div>
                                    </div> 
                                </div>
                                <div class="dishes-container">
                                    <div class="row">
                                    <div class="col-md-4 col-sm-4 col-xs-12 wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="dishes-list">
                                        <div class="dishes-img">
                                            <a href="#/">
                                            <img src="assets/images/dishes-item1.jpg" alt=""/>
                                            <div class="dishes_price">
                                                <div class="dishes-price-content">
                                                <div class="deshies-doll">$15</div>
                                                </div> {/* <!-- dishes-price-content --> */}
                                            </div> {/* <!-- dishes_price --> */}
                                            </a>
                                        </div> {/* <!-- dishes-img --> */}
                                        <div class="dishes-content text-left">
                                            <h3><a href="#/">Big Bur</a></h3>
                                            <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla</p>
                                            <a href="#/" class="btn-black">New</a>
                                        </div> {/* <!-- dishes-content -->  */}
                                        </div> {/* <!-- dishes-list -->  */}
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12 wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="dishes-list">
                                        <div class="dishes-img">
                                            <a href="#/">
                                            <img src="assets/images/dishes-item2.jpg" alt=""/>
                                            <div class="dishes_price">
                                                <div class="dishes-price-content">
                                                <div class="deshies-doll">$19</div>
                                                </div> {/* <!-- dishes-price-content -->  */}
                                            </div> {/* <!-- dishes_price -->  */}
                                            </a>
                                        </div> {/* <!-- dishes-img -->  */}
                                        <div class="dishes-content text-left">
                                            <h3><a href="#/">Quesadillas</a></h3>
                                            <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla</p>
                                            <a href="#/" class="btn-black">Chef Selection</a>
                                        </div> {/* <!-- dishes-content -->   */}
                                        </div> {/* <!-- dishes-list -->   */}
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12 wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="dishes-list">
                                        <div class="dishes-img">
                                            <a href="#/">
                                            <img src="assets/images/dishes-item3.jpg" alt=""/>
                                            <div class="dishes_price">
                                                <div class="dishes-price-content">
                                                <div class="deshies-doll">$21</div>
                                                </div> {/* <!-- dishes-price-content -->  */}
                                            </div>{/* <!-- dishes_price -->   */}
                                            </a>
                                        </div> {/* <!-- dishes-img -->   */}
                                        <div class="dishes-content text-left">
                                            <h3><a href="#/">Hamburger</a></h3>
                                            <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla</p>
                                            <a href="#/" class="btn-black">Recommended</a>
                                        </div> {/* <!-- dishes-content -->   */}
                                        </div> {/* <!-- dishes-list -->   */}
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12 wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="dishes-list">
                                        <div class="dishes-img">
                                            <a href="#/">
                                            <img src="/assets/images/dishes-item4.jpg" alt=""/>
                                            <div class="dishes_price">
                                                <div class="dishes-price-content">
                                                <div class="deshies-doll">$15</div>
                                                </div> {/* <!-- dishes-price-content -->  */}
                                            </div> {/* <!-- dishes_price -->  */}
                                            </a>
                                        </div> {/* <!-- dishes-img -->  */}
                                        <div class="dishes-content text-left">
                                            <h3><a href="#/">Fruits salad</a></h3>
                                            <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla</p>
                                            <a href="#/" class="btn-black">Recommended</a>
                                        </div> {/* <!-- dishes-content -->  */}
                                        </div> {/* <!-- dishes-list -->  */}
                                    </div>
                                    <div class="col-md-4 col-sm-4 col-xs-12 wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="dishes-list">
                                        <div class="dishes-img">
                                            <a href="#/">
                                            <img src="/assets/images/dishes-item5.jpg" alt=""/>
                                            <div class="dishes_price">
                                                <div class="dishes-price-content">
                                                <div class="deshies-doll"><del>$25</del>$21</div>
                                                </div> {/* <!-- dishes-price-content -->  */}
                                            </div> {/* <!-- dishes_price -->  */}
                                            </a>
                                        </div> {/* <!-- dishes-img -->  */}
                                        <div class="dishes-content text-left">
                                            <h3><a href="#/">Hamburger</a></h3>
                                            <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla</p>
                                            <a href="#/" class="btn-black">New</a>
                                        </div> {/* <!-- dishes-content -->  */}
                                        </div> {/* <!-- dishes-list -->  */}
                                    </div> 
                                    <div class="col-md-4 col-sm-4 col-xs-12 wow fadeInDown" data-wow-duration="1000ms" data-wow-delay="300ms">
                                        <div class="dishes-list">
                                            <div class="dishes-img">
                                                <a href="#/">
                                                <img src="/assets/images/dishes-item6.jpg" alt=""/>
                                                <div class="dishes_price">
                                                    <div class="dishes-price-content">
                                                    <div class="deshies-doll">$21</div>
                                                    </div> {/* <!-- dishes-price-content --> */}
                                                </div> {/* <!-- dishes_price --> */}
                                                </a>
                                            </div> {/* <!-- dishes-img --> */}
                                            <div class="dishes-content text-left">
                                                <h3><a href="#/">Salad</a></h3>
                                                <p>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla</p>
                                                <a href="#/" class="btn-black">Chef Selection</a>
                                            </div> {/* <!-- dishes-content --> */}
                                        </div> {/* <!-- dishes-list --> */}
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </section>      
                        {/* <section class="product-container">
                            <div class="container">                  
                                <div class="dishes-container">
                                    {this.plans.map((plan, index) => (
                                        <div class="col-md-4 col-sm-4 col-xs-12 wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                            <div class="dishes-list" style={{'backgroundColor' : '#000000'}}>
                                                <h2 style={{'color' : '#FFFFFF', 'padding' : '20px'}}>{plan.name}</h2>
                                                <div class="dishes-content text-left">
                                                    <p style={{'color' : '#FFFFFF', 'padding' : '10px'}}>Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla</p>
                                                </div>
                                                <ul className="mb-6 mt-6" style={{'padding' : '10px'}}>
                                                    {plan.features.map((feature, i) => (
                                                        <li key={i} style={{'color' : '#FFFFFF'}} className="text-white-700 text-left">
                                                            ✅ {feature}
                                                        </li>
                                                    ))}
                                                </ul>
                                                <a href="#/" class="btn-black" style={{'backgroundColor' : '#FFFFFF'}}>New</a>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </section> */}
                        
                        <section class="our-client-container">
                            <div class="container"> 
                            <div class="heading wow fadeInLeft" data-wow-duration="1000ms" data-wow-delay="300ms">
                                <div class="row">
                                <div class="text-center col-sm-12">
                                    <h2>What our clients say</h2>
                                </div>
                                </div> 
                            </div> {/* <!-- heading --> */}
                            <div class="our-client text-left">
                                <div class="col-md-4 col-sm-5 col-xs-12">
                                <div class="client-content wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <p><span class="quort">“</span>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                    <b>Alicia</b>
                                </div> {/* <!-- client-content --> */} 
                                <div class="client-content wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <p><span class="quort">“</span>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                    <b>Marissa</b>
                                </div> {/* <!-- client-content --> */}
                                <div class="client-content wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                    <p><span class="quort">“</span>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                    <b>Tom</b>
                                </div> {/* <!-- client-content --> */}
                                </div>
                                <div class="col-md-8 col-sm-7 col-xs-12 wow fadeInUp" data-wow-duration="1000ms" data-wow-delay="300ms">
                                <img src="/assets/images/client.jpg" alt=""/> 
                                </div>
                            </div> {/* <!-- our-client --> */}
                            </div>
                        </section>
                        <section class="find-container">
                            <div class="find-where-you">
                                <div class="food1">
                                    <img src="assets/images/food1.png" alt=""/>
                                </div>
                                <div class="container">
                                    <div class="row">
                                        <div class="col-md-6 col-sm-6 col-xs-12 find-location-left text-left">
                                            <h2>Where you can find us</h2>
                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                                        </div>
                                        <div class="col-md-6 col-sm-6 col-xs12 find-location-right">
                                            <div class="location"><i class="fa fa-map-marker" aria-hidden="true"></i></div>
                                            <div class="location-content text-left">
                                                <p>No 13, Emerald Hills, California, USA <br/> No 113, Farm Hill Blvd, California, USA <br/> No 97, Huddart Park, California, USA <br/> No 13, Alameda de las Pulgas, California, USA</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="food2">
                                    <img src="/assets/images/food2.png" alt=""/>
                                </div>
                            </div> {/* <!-- find-where-you --> */}
                        </section>
                        <div class="map-outer">
                            <div id="truck-locator"></div>
                        </div>
                    </div> {/* <!-- main-part --> */}
                </div>
            </div>
        )
    }
}